<template>
    <div class="pt-2 ">
        <!-- Base de l'arborescence -->
        <div v-for="groupBookmark in buildGroupsFromBookmarks(Bookmarks)" v-bind:key="'bookmark-[' + groupBookmark.Label + ']'" :style="'min-width: ' + minWidthMenu + '; max-height: ' + maxHeightMenu + ';'">
            <b-container >
                <b-row class="pl-3 pr-3 pt-0 pb-1">
                    <!--Icone du level 1 pour simplifier la visualisation -->
                    <b-col cols="1" :class="'border border-'+ Variant +' bg-'+ Variant +'-bg-subtle d-flex align-items-center justify-content-center py-1 img-circle'" >
                        <font-awesome-icon :icon="groupBookmark.Icon" size="lg" :class="Variant +'-light text-'+ Variant"/>
                    </b-col>
                    <!-- Label du "level 1" qui définit le groupe -->
                    <b-col class="d-flex align-items-center justify-content-start h6 text-black font-weight-semibold pt-2 pb-2 m-0 ">
                        {{ $t(groupBookmark.Label) }}
                    </b-col>
                </b-row>
                <b-row class="px-3 pt-0 pb-2">
                    <b-col class="p-0">
                        <b-list-group class="rounded-0 d-flex flex-column w-100 pl-2 pr-0 py-2" >
                            <b-list-group-item v-for="groupItem in groupBookmark.BookmarkGroupItems" v-bind:key="'bookmark-[ ' + groupItem.feature.Path + ']'" 
                                class="border-gray-middle-dark border-left-2-only d-flex flex-row h6 pl-3 pr-0 py-1 mb-0 justify-content-between">
                                <b-link :class="'d-flex flex-row text-decoration-none px-0 py-0 text-'+Variant" href="#" 
                                    @click="selectFeature(groupItem.feature)">
                                    <!-- Affichage du path avec le bon formatage ( délimiteur '>', couleurs, text-truncate, ...)-->
                                    <div v-for="format in getTranslateDescriptionPath(groupItem.bookmark,'>').slice(2)" 
                                        :class="'pl-0 py-0 pr-1 ' + ((!format.IsDelimiter) ? 'text-truncate ': ' ')" > {{ format.TranslateContent }}</div>
                                </b-link> <!--Liens pour naviger au click-->
                                <!-- Suppression du bookmark via une croix -->
                                <b-button @click="dropBookmark(groupItem.bookmark)" variant="none" class="p-0" >
                                    <b-icon icon="x" size="lg" class="text-danger" role="button" font-scale="1.5"/>
                                </b-button>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <!-- MODALE de remplacement d'un anciens bookmark par un nouveau bookmark -->
        <BookmarksReplace :Variant="Variant" :Bookmarks="Bookmarks" @validateEvent="validateReplace" :BookmarkToAdd="bookmarkToAdd" :AskShow.sync="askDeleteBookmark"/>
    </div>
</template>

<script lang="ts">
    /** Importe les d�corateurs pour utiliser @Component et @Prop */
    import { Vue, Component, Prop } from 'vue-property-decorator';
    import { mixins } from 'vue-class-component';
    import { Getter } from 'vuex-class';

    /** Types custom import� depuis /types */
    import Feature from '@/types/Feature';
    import Bookmark from '@/types/Bookmark';
	import Dictionary from "@/types/Dictionary";
    
    /** Fichiers de traductions */
    import locales from "./locales/BookmarksMenu.json";
    import featuresLocales from "@/locales/features.json";
    
    /** Classe mère pour faciliter la gestion des tailles d'écrans */
    import { ScreenUtils } from '@/components/commons/Utils';
    /** Classe mère pour faciliter le formatage des paths de marque-pages */
    import { BookmarkUtils } from './BookmarkUtils';

    /** Libs et constante pour utilisation des "WebApi". */
    import axios from 'axios';
    import { API_URL } from "@/App.settings";
    import BookmarksReplace from './BookmarkMenu/BookmarksReplace.vue';

    /** Composant d'affichage du menu listant les fonctions */
    @Component({
        components: {
            BookmarksReplace
        },
        i18n: { messages : locales }
    })
    export default class BookmarksMenu extends mixins(ScreenUtils, BookmarkUtils) {
        /** Constante fixant le nombre de "bookmarks" max pouvant être stocké */
        static readonly MAX_BOOKMARK_STORAGE = 10;

        /** Largueur horizontale minimal du menu */
        @Prop({ default: "19rem" })
        public minWidthMenu : string;

        /** Hauteur vertical maximum du menu */                 
        @Prop({ default: "80dvh" })
        public maxHeightMenu: string;

        /** Variant de thème utilisé par les pères */
        @Prop({ default: "primary" })
        public Variant!: string;

        @Prop({ default: [{}]})
        private Bookmarks!: Bookmark[];

        /** Bookmark à ajouter lorsqu'on dépasse le seuil limite */
        private bookmarkToAdd: Bookmark = { Feature: ""};
        /** Controle l'ouverture du menu de remplacement des bookmark */
        private askDeleteBookmark: boolean = false;
        
        /**
         * Action executé à la validation de la procédure de replace
         * @param bookmarksToAdd Bookmark à ajouter
         * @param bookmarksToDrop Bookmark à retirer
         */
        private async validateReplace(bookmarksToAdd: Bookmark[], bookmarksToDrop: Bookmark[] ) {
            await this.saveBookmark(bookmarksToAdd, bookmarksToDrop);
        }

        // *** Builder d'affichage ***

        /**
         * Construit une arborescence exploitable par la vue pour réaliser l'affichage en escalier
         * @param bookmarks Listes des bookmarks à afficher / manipuler
         */
        private buildGroupsFromBookmarks(bookmarks: Bookmark[]) : { [id: string]: BookmarkGroup; } {
            // Initialisation de la variable de résultat
            let groups : { [id: string]: BookmarkGroup; } = {};

            bookmarks.forEach(bookmark => {
                // On décompose le "path"
                let split : string[] = bookmark.Feature.split(' / ');
                // Si le "path" est valide alors on traite
                if(split.length > 0) {
                    // On récupère le path de la fonctionalitée racine de "level 1"
                    let rootPath = split[0];

                    // Si le groupe existe déjà on ajoute la fonctionalitée pointé par le "bookmark"
                    if(rootPath in groups)
                        groups[rootPath].BookmarkGroupItems.push({ bookmark: bookmark, feature: this.$store.getters['GetFeature'](bookmark.Feature)})
                    else { // Sinon on ajoute un autre groupe
                        let rootFeature : Feature = this.$store.getters['GetFeature'](rootPath);
                        groups[rootPath] = {
                            Label: rootFeature.Name,
                            Icon: rootFeature.Icon,
                            BookmarkGroupItems: [{ bookmark: bookmark, feature: this.$store.getters['GetFeature'](bookmark.Feature) }]
                        }
                    }
                }
            });
            
            // Résultat
            return groups;
        }

        // *** Handlers d'événements ***

        /**
         * Place ou retire une fonctionnalité de la liste des "bookmarks".
         * @param feature Fonctionnalité cible.
         */
        public async ToggleBookmark(feature: Feature) {
            if(feature.IsBookmark){
                // Demande la suppression du bookmark.
                await this.saveBookmark([],[ this.Bookmarks.find(b => b.Feature === feature.Path) ]).then(() => {
                    Vue.set(feature, 'IsBookmark', false);
                    this.$bvToast.toast(this.getTranslatePath(feature.Path), {
                            title: this.$t('DropBookmark').toString(), // "Favoris supprimé",
                            autoHideDelay: 3000,
                            variant: "success",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                });
            }
            else {
                if(Object.keys(this.Bookmarks).length < BookmarksMenu.MAX_BOOKMARK_STORAGE) {
                    // Demande l'ajout du bookmark.
                    await this.saveBookmark([{ Feature : feature.Path}],[]).then(() => {
                        Vue.set(feature, 'IsBookmark', true);
                        this.$bvToast.toast(this.getTranslatePath(feature.Path), {
                            title: this.$t('AddBookmark').toString(), // "Favoris ajouté",
                            autoHideDelay: 3000,
                            variant: "success",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    });
                }
                else {
                    this.bookmarkToAdd = { Feature : feature.Path};
                    this.askDeleteBookmark = true;
                }
            }
        }

        /**
         * Suppression d'un "bookmark".
         * @param bookmark "bookmark" à supprimer.
         */
        private async dropBookmark(bookmark: Bookmark) {
            await this.saveBookmark([],[bookmark]).then(() => {
                this.$bvToast.toast(this.getTranslatePath(bookmark.Feature), {
                        title: this.$t('DropBookmark').toString(), // "Favoris supprimé",
                        autoHideDelay: 3000,
                        variant: "success",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
            });
        }

        /**
		 * Sélection d'une fonction via un bookmark avec mise à jour du store global
		 * @param selectedBookmark Bookmark sélectionnée à charger
		 */
        private selectFeature(selectedFeature : Feature) {
            // Event pour le parent
            this.$emit('selectFeatureEvent', selectedFeature);
        }

        /** Méthode de mise à jour des marque-pages en ajout et suppression. */
        private async saveBookmark(toAdd: Bookmark[], toDrop: Bookmark[]) {
            const args: Dictionary<any> = {};
				args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
				args["BookmarksToDrop"] = toDrop;   // Liste des marque-pages à retirer
				args["BookmarksToAdd"] = toAdd;     // Liste des marque-pages à ajouter

            // Appel WebAPI pour la suppression et l'ajout de bookmark.
            await axios.post(API_URL + "navigation/updateBookmarks", args).then((response) => {
                if (response) {
                    // Refresh de la liste des marque-pages
                    this.$store.dispatch("LoadFeaturesMenu").catch(err => {
                        console.error(err);
                        this.$bvToast.toast(this.$t('BookmarkLoadingError').toString(), {	// "Une erreur s'est produite sur le chargement de la liste des fonctions."
                            title: this.$t('Error').toString(),	// "Erreur"
                            autoHideDelay: 10000,
                            variant: "danger",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    });
				}
            // Gestion d'une érreur
            }).catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('AnErrorOccuredUpdateBookmark').toString(), { // "Une erreur s'est produite."
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        }

        // *** Initialisateur ***

        /** Initialisation de la vue et du module de traduction */
        async created() {
            /** Chargement des traductions des features */
            this.$root.$i18n.mergeLocaleMessage(this.$i18n.locale, featuresLocales[this.$i18n.locale]);
        }

    };

    /** Type intermédiaire pour l'organisation de l'affichage des bookmarks */
    type BookmarkGroup = {
        Label: string;
        Icon: string;
        BookmarkGroupItems : { bookmark : Bookmark, feature : Feature }[]
    };

</script>

<style scoped>
.border-left-2-only{
        border-left: 2px solid;
        border-right: 0;
        border-top: 0;
        border-bottom: 0;
    }
</style>